<template>
  <div class="">
    <div id="CentreDiv">
      <h4 id="HeaderText">Current Device List Report</h4>
      <div id="CentreDiv">
        <b-row>
          <b-col cols="12" md="12">
            <div>
              <input
                type="checkbox"
                id="checkbox"
                v-model="ReportStatusSelect"
              />
              <label for="checkbox">Include Device Risk Status</label>
            </div>
          </b-col>
        </b-row>

        <img
          id="menuGraphic"
          align="right"
          src="../assets/PDFIconSmall.png"
          v-on:click="func1()"
        />
        <img
          id="menuGraphic"
          align="right"
          src="../assets/excelSmall.png"
          v-on:click="
            exportTableToExcel(
              'DeviceReport',
              'Device_Report_Export_' + new Date().toLocaleDateString()
            )
          "
        />

        <div id="Logo">
          <img
            v-if="this.printVisible == 'true'"
            id="menuGraphic"
            align="right"
            src="../assets/logo.png"
          />

          <img
            v-if="this.printVisible == 'true'"
            id="menuGraphic"
            align="left"
            src="../assets/logo.png"
          />
        </div>
      </div>
    </div>
    <div id="DeviceReport">
      <br />
      <h5 id="TableHead">{{ this.SearchedBy }}</h5>
      <div id="TableDiv">
        <h5>Location: {{ this.UserLocation }}</h5>
        <div id="SupportTable" v-if="this.ReportStatusSelect == false">
          <b-table
            stacked="md"
            id="statusTable"
            hover
            striped
            :items="this.items"
            :fields="this.UserHeaders"
            show-empty
            empty-text="No Devices at Your Location"
            head-variant="dark"
            table-variant="light"
            small
            bordered
          >
            <template v-slot:empty="scope">
              <h4>{{ scope.emptyText }}</h4>
            </template>
          </b-table>
          <br />
        </div>
        <div id="SupportTable" v-if="this.ReportStatusSelect == true">
          <b-table
            stacked="md"
            id="statusTable"
            hover
            striped
            :items="this.statusitems"
            :fields="this.UserHeaders"
            show-empty
            empty-text="No Devices at Your Location"
            head-variant="dark"
            table-variant="light"
            small
            bordered
          >
            <template v-slot:empty="scope">
              <h4>{{ scope.emptyText }}</h4>
            </template>
          </b-table>
          <br />
        </div>
      </div>
    </div>
    <div id="ReportErrorMessage" v-if="this.ReportError === 'True'">
      <h5>Current Search Returns No Data</h5>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  computed: {
    rows() {
      return this.items.length;
    },
  },
  data() {
    return {
      UnitID: "",
      perPage: 10,
      currentPage: 1,
      location: "",
      locations: [],
      filteredlocations: [],
      FromDate: "",
      ToDate: "",
      modal: false,
      showReport: "False",
      selectedReport: null,
      CounterVal: null,
      ReportError: "False",
      stateArray: [],
      locationsArray: [],
      deviceStatusSearch: "",
      deviceLocationSearch: "",
      Company: this.$Company,
      responseArray: [],
      responselist: [],
      items: [],
      UserHeaders: [],
      SearchedBy: "",
      reports: [
        { ReportID: "1", ReportName: "Countermeasure Report" },
        /* { ReportID: "2", ReportName: "Consumables Report" }*/
      ],
      win: {},
      printVisible: "false",
      myVar: "",
      UserLocation: this.$Location,
      ReportStatusSelect: false,
      StatusResponseArrary: [],
      statusitems: [],
    };
  },
  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/search";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "DeviceLocation",
      RequestVariable: this.UserLocation,
      Company: this.Company,
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        this.responselist = response.data.Values;

        for (let i = 0; i < this.responselist.length; i++) {
          var QuoteStr = this.responselist[i][0];
          this.responseArray.push({
            DeviceID: QuoteStr,
            Floor: this.responselist[i][7],
            Position: this.responselist[i][5],
            Feed: this.responselist[i][6],
            DeviceStatus: this.responselist[i][3],
          });
        }

        this.items = this.responseArray;

        for (let i = 0; i < this.responselist.length; i++) {
          var QuoteStr2 = this.responselist[i][0];
          this.StatusResponseArrary.push({
            DeviceID: QuoteStr2,
            Floor: this.responselist[i][7],
            Position: this.responselist[i][5],
            Feed: this.responselist[i][6],
            DeviceStatus: this.responselist[i][3],
            RiskLevel: this.responselist[i][2],
          });
        }
        this.statusitems = this.StatusResponseArrary;
      });
  },

  methods: {
    exportTableToExcel: function(tableID, filename = "") {
      var downloadLink;
      var dataType = "application/vnd.ms-excel";
      var tableSelect = document.getElementById(tableID);
      var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");

      // Specify file name
      filename = filename ? filename + ".xls" : "excel_data.xls";

      // Create download link element
      downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(["\ufeff", tableHTML], {
          type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = "data:" + dataType + ", " + tableHTML;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
        location.reload();
      }
    },

    func1() {
      this.printVisible = "true";

      setTimeout(() => this.createPDF(), 1);
    },

    createPDF: function() {
      var TableHead = document.getElementById("TableHead").innerHTML;
      var sTable = document.getElementById("TableDiv").innerHTML;
      var Logo = document.getElementById("Logo").innerHTML;

      let current = new Date();
      let HistoryDate =
        current.getDate() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getFullYear();

      var style = "<style>";
      style = style + "table {width: 100%;font: 12px Verdana;}";
      style =
        style +
        "table, th, td {border: solid 1px #DDD; border-collapse: collapse; text-align:centre;";
      style = style + "padding: 2px 3px;text-align: center;}";
      style = style + "</style>";

      // CREATE A WINDOW OBJECT.
      this.win = window.open("", "", "height=700,width=700");

      this.win.document.write("<html><head>");
      this.win.document.write("<title>Current Device Status Report</title>"); // <title> FOR PDF HEADER.
      this.win.document.write(style); // ADD STYLE INSIDE THE HEAD TAG.
      this.win.document.write("</head>");
      this.win.document.write("<body>");
      this.win.document.write(Logo);
      this.win.document.write(
        "<h3 style='text-align:center;'>" + HistoryDate + " </h3>"
      );
      this.win.document.write(
        "<h2 style='text-align:center;'> Current Device Status </h2>"
      );

      this.win.document.write(
        "<h3 style='text-align:center;'>" + TableHead + " </h3>"
      );
      this.win.document.write(sTable); // THE TABLE CONTENTS INSIDE THE BODY TAG.
      this.win.document.write("</body>");

      this.win.document.write("</html>");
      this.printVisible = "false";
    },

    PrintMe() {
      this.win.print();
      this.win.close();
    },

    resetValue: function() {
      this.location = "";
      this.modal = false;
      this.FromDate = "";
      this.ToDate = "";
      this.showReport = "False";
      this.selectedReport = null;
      this.UnitID = "";
      this.CounterVal = null;
      this.ReportError = "False";
      (this.responseArray = []),
        (this.responselist = []),
        (this.items = []),
        (this.UserHeaders = []);
      (this.deviceStatusSearch = ""), (this.deviceLocationSearch = "");
      this.SearchedBy = "";
    },

    filterLocations: function() {
      if (this.location.length == 0) {
        this.filteredlocations = this.locations;
      }
      this.filteredlocations = this.locations.filter((location) => {
        return location
          .toString()
          .toLowerCase()
          .startsWith(this.location.toString().toLowerCase());
      });
    },

    DynamicSelect: function() {
      if (this.deviceStatusSearch == "" && this.deviceLocationSearch == "") {
        alert("Please select a field to filter on");
      } else if (
        this.deviceStatusSearch != "" &&
        this.deviceLocationSearch != ""
      ) {
        (this.deviceStatusSearch = ""),
          (this.deviceLocationSearch = ""),
          alert("Please select a single field to filter on");
      } else {
        if (this.deviceLocationSearch != "") {
          this.items = [];
          this.responseArray = [];

          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/search";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "DeviceLocation",
            RequestVariable: this.deviceLocationSearch.text,
            Company: this.Company,
          };
          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              this.responselist = response.data.Values;

              for (let i = 0; i < this.responselist.length; i++) {
                var QuoteStr = this.responselist[i][0];
                this.responseArray.push({
                  DeviceID: QuoteStr,
                  Position: this.responselist[i][5],
                  Feed: this.responselist[i][6],
                  Floor: this.responselist[i][7],
                  DeviceState: this.responselist[i][3],
                });
              }

              this.items = this.responseArray;
              this.showReport = "True";

              this.SearchedBy = "Location : " + this.deviceLocationSearch.text;
            });
        } else if (this.deviceStatusSearch != "") {
          this.items = [];
          this.responseArray = [];

          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/search";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "DeviceStatus",
            RequestVariable: this.deviceStatusSearch.id,
            Company: this.Company,
          };
          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              this.responselist = response.data.Values;

              for (let i = 0; i < this.responselist.length; i++) {
                var QuoteStr = this.responselist[i][0];
                this.responseArray.push({
                  DeviceID: QuoteStr,
                  Location: this.responselist[i][1],
                  Position: this.responselist[i][6],
                  Feed: this.responselist[i][7],
                  Floor: this.responselist[i][8],
                });
              }
              this.items = this.responseArray;
              this.showReport = "True";
              this.SearchedBy =
                "Status Level : " + this.deviceStatusSearch.text;
            });
        }
      }
    },

    setLocation(location) {
      this.location = location;
      this.modal = false;
    },
  },

  watch: {
    location() {
      this.filterLocations();
    },
  },
};
</script>

<style scoped>
select {
  width: 33%;
}

input[type="text"],
select {
  width: 80%;

  padding: 7px 7px 7px 7px;

  border: solid 1px rgba(200, 200, 200, 0.5);

  border-radius: 15px;

  background-color: rgb(245, 245, 245);
}

input[type="checkbox"] {
  width: 1rem;
  margin: 0px 0;

  padding: 2px 8px;
  position: relative;
}

table tr {
  background-color: #f2f2f2;
  color: black;
  text-align: center;
  font-size: small;
}

#TitleSection {
  padding-top: 10px;
  padding-bottom: 15px;
}
#CentreDiv {
  text-align: center;
  padding-bottom: 10px;
}

#SupportTable {
  padding: 1.5rem;
}

#CentreDiv {
  text-align: center;

  padding-top: 1rem;

  margin-left: 3rem;
  margin-right: 3rem;
}
</style>
